import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { globalModalListAtom, type GlobalModalOptions } from "../store";
import { safeUUID } from "../utils";

/**
 * 全局弹窗 hook
 * @returns 
 */
export default function useGlobalModal() {
  const setModalList = useSetAtom(globalModalListAtom);

  /**
   * 插入全局弹窗
   */
  const pushGlobalModal = useCallback((options: GlobalModalOptions) => {
    setModalList(prev => {
      if (options.id) {
        const idx = prev.findIndex(item => item.id === options.id);
        // 如已经存在，则更新数据
        if (idx >= 0) {
          const copy = [...prev];
          copy[idx] = { ...copy[idx], ...options };
          return copy;
        }
      }
      const params = { order: 0, ...options, id: options.id ?? safeUUID() };
      // 降序排序
      return [...prev, params].sort((a, b) => (b.order || 0) - (a.order || 0));
    });
  }, [setModalList]);

  /**
   * 移除弹窗
   */
  const removeGlobalModal = useCallback((id?: string | number) => {
    setModalList(prev =>
      id !== undefined
        ? prev.filter(item => item.id !== id)
        : prev.slice(1)
    );
  }, [setModalList]);

  return {
    pushGlobalModal,
    removeGlobalModal
  };
}